import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { QuickCreateCardDialogComponent } from './features/card-create/quick-create-card-dialog.component';
import { EncryptionPasswordDialogComponent } from './shared/components/encryption-password-dialog/encryption-password-dialog.component';

interface NavigationItem {
  label: string;
  route: string;
  description: string;
}

@Component({
  selector: 'app-root',
  imports: [
    EncryptionPasswordDialogComponent,
    QuickCreateCardDialogComponent,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected readonly title = signal('Project Planning App');
  protected readonly showQuickCreateDialog = signal(false);
  protected readonly navigationItems: readonly NavigationItem[] = [
    {
      label: 'Ladder',
      route: '/ladder',
      description: ''
    },
    {
      label: 'All Cards',
      route: '/all-cards',
      description: ''
    },
    {
      label: 'Categories',
      route: '/categories',
      description: ''
    },
    {
      label: 'Import / Export',
      route: '/import-export',
      description: ''
    }
  ];

  protected openQuickCreateDialog(): void {
    this.showQuickCreateDialog.set(true);
  }

  protected closeQuickCreateDialog(): void {
    this.showQuickCreateDialog.set(false);
  }
}
